<template>
  <v-slide-y-transition>
    <div
      v-if="brandGroupsMatchingSearchText.length > 0"
      class="mt-1"
      style="color: rgba(0, 0, 0, 0.54)"
    >
      {{ $t('foundMatchingBrandGroupsHint') }}
      <v-chip
        v-for="brandGroup in brandGroupsMatchingSearchText"
        :key="brandGroup.id"
        small
        outline
        color="msr"
        class="clickable"
        @click="chooseSingleBrandGroup(brandGroup)"
      >
        <v-avatar class="mr-0">
          <v-icon dark>
            add
          </v-icon>
        </v-avatar>
        {{ brandGroup.name }}
      </v-chip>
    </div>
  </v-slide-y-transition>
</template>

<script>
import initializeFuseJsInstance from '@/fuzzySearch';

export default {
  props: {
    searchText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      fuse: null,
    };
  },
  computed: {
    chosenBrandGroupIds() {
      if (!this.$user) {
        return [];
      }
      return this.$userprofile.chosen_brand_groups;
    },
    availableBrandGroups() {
      if (!this.$user) {
        return [];
      }
      return this.$userprofile.available_brand_groups;
    },
    /**
     * Match brand Group names that are similar to the search text.
     *
     * The brand Groups must not be chosen/subscribed to by the User already.
     * Do nothing for very short searches to avoid spamming.
     */
    brandGroupsMatchingSearchText() {
      const search = (this.searchText || '').toLowerCase();
      if (!search || search.length < 3) {
        return [];
      }

      if (!this.fuse) {
        this.initFuzzySearch();
      }

      let groups = this.fuse.search(search);
      groups = groups.filter((group) => {
        const alreadyChosen = this.chosenBrandGroupIds.indexOf(group.id) !== -1;
        return !alreadyChosen;
      });
      return groups;
    },
  },
  methods: {
    initFuzzySearch() {
      this.fuse = initializeFuseJsInstance(this.availableBrandGroups, ['name']);
    },
    chooseSingleBrandGroup(brandGroup) {
      this.$store.dispatch('CHOOSE_SINGLE_BRAND_GROUP', brandGroup).then(() => {
        this.$router.push({
          path: '/brands',
          query: {
            scroll: brandGroup.id,
          },
        });
      });
    },
  },
};
</script>

<style scoped>
.clickable >>> .v-chip__content:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BrandGroupSearchMatches.vue